import styled from 'styled-components';

export default styled.nav`
  position: sticky;
  top: 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: white;
  border-bottom: 1px solid #eee;
  color: #000;
  z-index: 7;
`;
